import React from 'react';
import classNames from 'classnames';
import './index.scss';
import {columnIsRequired} from '../../../services/filter';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';
import IconButton from '../IconButton/index.js';
import {handleMaxValueError, handleMinValueError} from '../SectionItemAudienceFilter/audienceFilterHelpers.js';


const SectionItemPercent = ({ column, item, value, error, onPropChange, withTitle = true, withReset = false, allItems }) => {
  const isItemValid = column && column?.isItemValid ? !column.isItemValid(item) : false;
  // eslint-disable-next-line
  const isEmpty = value === null && parentValue === undefined;

  const handleOnPropChange = e => {
    let inputValue = e?.currentTarget?.value

    if(!inputValue) {
      return onPropChange({ [column.accessor]: null });
    }


    // const findMinus = inputValue.match(/^[0-9]+-.*[0-9]*$/) !== null && inputValue.match(/^[0-9]+-.*[0-9]*$/)[0].indexOf('-') !== 0;

    if(inputValue && inputValue.length > 1 && inputValue[0] !== '-' && inputValue.includes('-')){
      inputValue = '-';
    }


    const maxValue = +column.max || 100;
    const minValue = +column.min || 0;

    if (inputValue < minValue) {
      return handleMinValueError(minValue + '%');
    }

    if (inputValue > maxValue) {
      return handleMaxValueError(maxValue + '%');
    }

    const regex = /^-?(?:\d+(\.\d{0,5})?)?$/;
    if (!inputValue.match(regex)) {
      return;
    }

    if(!inputValue.includes('0.') && !isEmpty){
      inputValue = inputValue.replace(/^0+/, '');
    }

    onPropChange({ [column.accessor]:  inputValue });

  };

  const handleResetValue = () => {
    onPropChange({ [column.accessor]: null });
  };

  const parentValue = item['parent' + column.accessor];

  const mergedValue = ((value || (value === 0 && parentValue === null) ? value : parentValue) || 0).toString();



  return (
    <div
      key={`sectionItemPercent-${column.accessor}`}
      className={classNames('sectionItemPercent', column.inlineType, { withFormated: column.formatedFn })}
    >
      {withTitle && <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />}
      <form
        autoComplete='off'
        className={classNames('inputItem', {
          required: columnIsRequired(column, item) || isItemValid,
          isBlue: withReset && value !== 0 && value !== null,
          isGreen: column.isGreen && value !== 0 && value !== null,
          withoutBorder: column?.withoutBorder,
        })}
      >
        <input
          type='text'
          className={classNames({ hasError: column.hasError && column.hasError(error) })}
          placeholder={column.placeholder || null}
          value={mergedValue}
          readOnly={column.isReadonly}
          onChange={handleOnPropChange}
          // onKeyDown={handleOnKeyDown}
        />
        <div className={'percent'} style={{left: (mergedValue.length * 6 || 0) + 25 + 'px'}}> % </div>
        {!column.isReadonly && withReset && value !== null && value !== 0 && (
          <div className={'resetIconWrapper'}>
            <IconButton isIcon iconName={'resetIcon'} onClick={handleResetValue} />
          </div>
        )}
      </form>
    </div>
  );
};

export default SectionItemPercent;
